import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Layout } from 'antd';
import { useTheme } from '../contexts/ThemeContext';
import { PageSkeleton } from './Common/Skeletons';
import { isMcpAuthorizePath, signedOutTarget, trackMcpStep } from '../utils/mcpConnectFunnel';

const { Content } = Layout;

const ProtectedRoute = ({ children }) => {
  const { currentUser, profileLoading } = useAuth();
  const { isDarkMode } = useTheme();
  const location = useLocation();

  const signedOutOnAuthorize = !profileLoading && !currentUser && isMcpAuthorizePath(location.pathname);
  useEffect(() => {
    if (signedOutOnAuthorize) trackMcpStep('request_started', { signed_in: false });
  }, [signedOutOnAuthorize]);
  
  // Show loading skeleton only during genuine initial auth/profile loading.
  // AuthContext already gates rendering with {!loading && children}, so by the
  // time ProtectedRoute mounts, Firebase auth state is fully resolved.
  // For in-app navigation (where profileLoading is already false), children
  // render immediately with zero delay — no full-page skeleton flash.
  if (profileLoading) {
    return (
      <div style={{ 
        height: '100vh', 
        width: '100vw',
        backgroundColor: isDarkMode ? '#141414' : '#f0f2f5'
      }}>
        <Content style={{ padding: '24px' }}>
          <PageSkeleton rows={4} title={false} />
        </Content>
      </div>
    );
  }

  // Redirect to login (sign-up for /authorize) if not authenticated
  if (!currentUser) {
    // Save the current location to redirect back after login
    return <Navigate to={signedOutTarget(location.pathname)} state={{ from: location }} replace />;
  }

  // User is authenticated, render children
  // (Account verification gate is handled by GlobalLayout for all pages)
  return children;
};

export default ProtectedRoute;
